import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { usePipedriveCallback } from "../../api/pipedrive/usePipedriveCallback";
import LoadingScreen from "../../features/Layout/LoadingScreen/LoadingScreen";

type PipedriveSearch = {
  code: string;
  state: string;
};

export const Route = createFileRoute("/oauth/pipedrive/callback")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): PipedriveSearch => {
    return {
      code: (search.code as string) || "",
      state: (search.state as string) || "",
    };
  },
});

function RouteComponent() {
  const { code, state } = Route.useSearch();

  const { mutate } = usePipedriveCallback();

  useEffect(() => {
    mutate({ code, state });
  }, []);

  return <LoadingScreen />;
}
